import { GerenciarOcorrenciasService } from 'src/app/services/gerenciar-ocorrencias.service';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { take } from 'rxjs/operators';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { AlertHistoricoAnotacoesOcorrenciasComponent } from '../../components/alert-historico-anotacoes-ocorrencias/alert-historico-anotacoes-ocorrencias.component';
import { LoadingGenericoComponent } from '../../components/loading-generico/loading-generico.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { AlertArquivosAnexadosComponent } from '../../components/alert-arquivos-anexados/alert-arquivos-anexados.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-detalhes-ocorrencia',
    templateUrl: './detalhes-ocorrencia.component.html',
    styleUrls: ['./detalhes-ocorrencia.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, AlertHistoricoAnotacoesOcorrenciasComponent, LoadingGenericoComponent, BreadcrumbComponent, RouterLink, AlertArquivosAnexadosComponent, FooterComponent, DatePipe]
})
export class DetalhesOcorrenciaComponent implements OnInit {

  public showAlertAnotacoesOcorrencias: boolean = false;
  public checkBox: boolean = false;

  public idOcorrencia:number;
  public resources: any;
  public loadingGenerico: boolean  = false;
  public isShowArquivosAnexados = false;

  constructor( 
    private readonly activatedRoute: ActivatedRoute,
    private readonly gerenciarOcorrenciasService : GerenciarOcorrenciasService
  ) {}

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(
      (params) => {
        if (params.idOcorrenciaPai) {
          //é edição
          this.idOcorrencia = params.idOcorrenciaPai;
        }
      }
    );
    this.getAllHistorico();


  }

  abrirFecharArquivosAnexados(): void {

    this.isShowArquivosAnexados = !this.isShowArquivosAnexados;
  }

  public eventoAlertAnotacoesOcorrencias(evento: any) {
    this.showAlertAnotacoesOcorrencias = evento;
  }

  public alertAnotacoesOcorrencias() {
    this.showAlertAnotacoesOcorrencias = true;


  }

  public eventoAlertAlterarEmpresaFechou(event: any) {
    this.showAlertAnotacoesOcorrencias = event;
  }


  public getAllHistorico() {

    this.loadingGenerico = true;
    this.gerenciarOcorrenciasService.getDetalhesOcorrencia(this.idOcorrencia)
    .pipe(take(1)).subscribe({
      next: (success: any) => {
        this.loadingGenerico = false;
        this.resources = success.response;
      },
      error: () => {
        this.loadingGenerico = false;
      }
    });
  }
}
